import Vue from 'vue';
import Vuex from 'vuex';

import userModule from './modules/user';
import organizationModule from './modules/organization';
import questWizardModule from './modules/questWizard';
import questListModule from './modules/questList';
import questDetailsModule from './modules/questDetails';
import dashboardModule from './modules/dashboard';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        prefetchInProgress: false,
        forcePrefetch: false,
        authError: null,
    },
    mutations: {
        setPrefetchInProgress: (state, prefetchInProgress) => state.prefetchInProgress = prefetchInProgress,
        setForcePrefetch: (state, forcePrefetch) => state.forcePrefetch = forcePrefetch,
        setAuthError: (state, authError) => state.authError = authError,
    },
    actions: {},
});

store.registerModule('user', userModule);
store.registerModule('organization', organizationModule);
store.registerModule('questWizard', questWizardModule);
store.registerModule('questList', questListModule);
store.registerModule('questDetails', questDetailsModule);
store.registerModule('dashboard', dashboardModule);

Vue.$store = store;
Vue.prototype.$store = store;

export default store;
